import * as React from "react"
import { connect } from "react-redux"

import { GlobalState } from "../../../store"
import { mapDispatchToProps, DispatchProps } from "../../search/actions"
import SimpleSearchField from "../../search/simple/SimpleSearchField"
import SmartSearchInput from "../../search/smart/components/SearchInput"
import { ISearch } from "../../search"

interface OwnProps {
    isSmartSearch: boolean
}

type StateProps = ISearch

type Props = OwnProps & StateProps & DispatchProps

export const Search = ({ isSmartSearch }: Props): JSX.Element =>
    isSmartSearch ? (
        <SmartSearchInput isInverted={true} />
    ) : (
        <SimpleSearchField
            background="transparent"
            showButtonsOnlyIfFocus={true}
        />
    )

const mapStateToProps = (state: GlobalState): StateProps => state.search

export default connect(mapStateToProps, mapDispatchToProps)(Search)
